import axiosInstance from "./AxiosInstance";
export function getoccupancybyroute(param={}){
     const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/transport/analytics/bus_occupancy_route?${fparam}`);
}
export function getutilizeshift(param={}){
     const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/transport/analytics/bus_utilization_shift?${fparam}`);
}
export function analyticspopularstop(param={}){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/transport/analytics/most_popular_stop?${fparam}`);
}
export function analyticsgenderdistribution(param={}){
     const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/transport/analytics/gender_distribution?${fparam}`)
}
// export function analyticsbuspassoccupancyroute(){
//     return axiosInstance.get('api/transport/analytics/buspass_occupancy_route');
// }
export function analyticsBusArrivalApi(param={}){
     const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/transport/analytics/bus_arrival_status_count?${fparam}`)
}
export function analyticsBusUtilization(param = {}) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(
    `api/transport/reports/bus_utilization_report?${fparam}`
  );
}
export function analyticsBusoccupancyApi(param = {}) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(
    `api/transport/reports/bus_occupancy_report?${fparam}`
  );
}
export function analyticsRouteWiseBusOccupancy(param = {}) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(
    `api/transport/analytics/route_wise_bus_occupancy?${fparam}`
  );
}
export function analyticsBusTravelApi(param = {}) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(
    `api/transport/analytics/bus-distance-distribution/?${fparam}`
  );
}